import { useDispatch } from "react-redux";
import { OpenXLogo } from "../../assets";
import { ButtonsContainer } from "../buttonsContainer";
import { SearchBar } from "../searchBar";
import styles from "./style.module.css"
import { setCartVisibility } from "../../redux/slices/cartVisibilitySlice";
import { useNavigate } from "react-router";

interface INavBarProps{
    onSearchClick?: () => void;
  onSearchBlur?: () => void;
}

export const NavBar: React.FC<INavBarProps> = ({onSearchClick, onSearchBlur}) => {

    // const {setIsCartVisible} = useCartVisibility();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
      <nav className={styles.nav}>
        {/* <LuxfricaIcon className={styles.icon}/> */}

        <div onClick={() => dispatch(setCartVisibility(true))}>
          {/* <button className={styles.btn}> */}
          {/* O p e n - X */}
          {/* <LuxfricaIcon className={styles.icon}/> */}
          <OpenXLogo className={styles.icon} onClick={() => {navigate("/")}}/>
          {/* </button> */}
        </div>

        <SearchBar onInputClick={onSearchClick} onInputBlur={onSearchBlur} />

        <ButtonsContainer />
      </nav>
    );
}

